<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/studies">Accueil</a></li>
                <li>Dashboard</li>
            </ul>
            <h2>
                <i style="color:white" class=" iconModule bx bx-chalkboard"></i> Dashboard
            </h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>
<div class="courses-details-area pb-100">
    <div class="container">
        <div class="row h-100 justify-content-center align-items-center">


        </div>
    </div>
</div>




<div class="cart-area " style="margin-top:-50px">
    <div class="container">


        <div class="profile-courses-quizzes">
            <ngx-tabset >
                <ngx-tab tabTitle="Modules">

<div class="bg-light d-flex ">
    <div class="container py-5">
        <div class="bg-white p-4 rounded shadow-sm w-100" style="max-width: 600px; margin: auto;">

            <h3 class="mb-3">
                La formation comprend 4 niveaux
            </h3>
            <p class="text-muted">
                Explorez l’ensemble des niveaux d'étude! Suivez la progréssion de tous vos modules
            </p>

            <div style="cursor:pointer" (click)="courses(item)"  *ngFor="let item of items"
                class="mb-3 p-3 border bg-light rounded d-flex align-items-center">
                <!-- Partie Texte et Progression -->

                <div class="flex-grow-1 me-3">
                    <strong> <span *ngIf="item.level == '3'||item.level == '4'" class="card-text"> <a style="color: var(--bs-secondary) !important;
                font-size: 18px;
                border-radius: 50%;
                padding: 4px;
                border: 3px solid #97245b;" href="javascript: void(0)">N{{item.level}}</a></span>
                        <span *ngIf="item.level == '1'||item.level == '2'" class="card-text"> <a style=" color: var(--bs-secondary) !important;
                    font-size: 18px;
                    border-radius: 50%;
                    padding: 4px;
                    border: 3px solid #dca119;" href="javascript: void(0)">N{{item.level}}</a></span><span
                            style="margin-left:-10px">{{ item.title }}</span></strong>
                    <p style="margin-top:10px">– {{ item.description}}</p>
                    <!-- Barre de progression ajoutée ici -->
                    <div class="mt-2">
                        <div class="progress-bar-container">
                            <div class="progress-bar-bg">
                                <div class="progress-bar-fill" [style.width.%]="item?.progression?.prog || 0"></div>
                            </div>
                            <span class="progress-bar-text">{{ item?.progression?.prog || 0 }}%</span>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
    </div>

                    <!-- <div class="bg-light d-flex "  style="cursor:pointer">
                        <div class="container py-5">
                            <div class="row">
                       
                                <div (click)="courses(item)" *ngFor="let item of items"
                                    class="col-xl-6  col-sm-12  d-flex justify-content-center">
        
                                    <div style="background:white;margin-top:34px;" class="cardText lesson w-100">
                                        <div class="card-body" style="padding:10px">
                                            <h5><div class="d-flex align-items-center" style=" margin-top: 13px;">
                                                <div class="card-title  "><span   *ngIf="item.level == '1'||item.level == '2'" class="card-text"> <a style=" color: var(--bs-secondary) !important;
                                                    font-size: 18px;
                                                    border-radius: 50%;
                                                    padding: 4px;
                                                    border: 3px solid #dca119;" href="javascript: void(0)">N{{item.level}}</a></span>
                                                                    <span    *ngIf="item.level == '3'||item.level == '4'"  class="card-text"> <a style="    color: var(--bs-secondary) !important;
                                                    font-size: 18px;
                                                    border-radius: 50%;
                                                    padding: 4px;  
                                                    border: 3px solid #97245b;" href="javascript: void(0)" >N{{item.level}}</a></span></div>
                                                <div class="fw-bold capitalize-text"  style="color: var(--bs-secondary);">
                                                    {{item.title }}
                                                </div>
                                              </div></h5>
                                                   
                                           <p style="margin-top:17px;margin-top:34px;    margin-bottom: 20px;">– {{ item.description}}  </p>

                                        </div>
                                    </div>
        
                                </div>
                            </div>
                           
                        </div>
                    </div> -->
                   
                </ngx-tab>
                <ngx-tab tabTitle="Contrôles continus postés">


                   

                    <div class="bg-light d-flex "  style="cursor:pointer">
                        <div class="container py-5">
                            <div class="row">
                       
                                <div *ngFor="let item of lastControles"
                                    class="col-xl-6  col-sm-12  d-flex justify-content-center">
        
                                    <div style="background:white;margin-top:34px" class="cardText lesson w-100">
                                        <div class="card-body" style="padding:10px">
                                            <h5><div class="d-flex align-items-center" style=" margin-top: 13px;">
                                                <div class="card-title  "><span   *ngIf="item.level == '1'||item.level == '2'" class="card-text"> <a style=" color: var(--bs-secondary) !important;
                                                    font-size: 18px;
                                                    border-radius: 50%;
                                                    padding: 4px;
                                                    border: 3px solid #dca119;" href="javascript: void(0)">N{{item.level}}</a></span>
                                                                    <span    *ngIf="item.level == '3'||item.level == '4'"  class="card-text"> <a style="    color: var(--bs-secondary) !important;
                                                    font-size: 18px;
                                                    border-radius: 50%;
                                                    padding: 4px;  
                                                    border: 3px solid #97245b;" href="javascript: void(0)" >N{{item.level}}</a></span></div>
                                                <div class="fw-bold capitalize-text"  style="color: var(--bs-secondary);">
                                                    {{item.doc?.label||'Aucun contrôles disponibles' }}
                                                </div>
                                              </div></h5>
                                           
        
                                           <p *ngIf="item.doc" style="margin-top:30px">  {{item.description|| 'Ce contrôle continu est là pour vous accompagner dans votre apprentissage. Pas de stress : l’important est de faire de votre mieux. Installez-vous confortablement, respirez, et prenez le temps d’aborder chaque question avec réflexion. Chaque pas, même petit, vous rapproche de vos objectifs. Courage, vous allez y arriver !'}}</p>
        
                                           <p *ngIf="!item.doc" style="margin-top:17px;margin-top:34px">– <a class="title"> {{item.receivedDoc||0 }} </a> copie(s) déposé(es)</p>

                                        </div>
                                    </div>
        
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </ngx-tab>

            </ngx-tabset>
        </div>
    </div>
</div>
